<path
    class="Path_2"
    data-name="Path 2"
    d="M8.218,15.237,12.652,10.8a1.592,1.592,0,0,0,.484-1.129V1.612A1.617,1.617,0,0,0,11.523,0H4.267A1.593,1.593,0,0,0,2.816.967L.156,7.094A2.444,2.444,0,0,0,2.413,10.48h4.6L6.2,14.189a1.445,1.445,0,0,0,.322,1.129A1.247,1.247,0,0,0,8.218,15.237ZM16.36,0a1.617,1.617,0,0,0-1.612,1.612V8.062a1.612,1.612,0,0,0,3.225,0V1.612A1.617,1.617,0,0,0,16.36,0Z"
    transform="translate(19 17) rotate(180)"
    fill="currentColor"
/>
